import { nodeIds as GoogleAdsAnalyserNodeIds  } from "@/agents/google-ads-campaign-analyser/constants";
import { nodeIds as LinkedinAdsAnalyserNodeIds } from "@/agents/linkedin-ads-campaign-analyser/constants";
import { nodeIds as SalesBattleCardGeneratorNodeIds } from "@/agents/sales-battle-card-generator/constants";
import type { RawAnalysisData as GoogleAdsAnalysisData } from '@/agents/google-ads-campaign-analyser/components/types';
import type { RawAnalysisData as LinkedinAnalysisData } from '@/agents/linkedin-ads-campaign-analyser/components/types';

type AgentConfig = {
    nodeId: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extractSidebarData: (output: unknown) => any;
  };
interface RawBattleCardData {
  battle_card_report?: string;
  research_content?: string;
  battle_card_guide?: string;
  battle_card_outline?: string;
}
export function getAgentSidebarConfig(agentId: string): AgentConfig {
  switch (agentId) {
    case "google-ads-campaign-analyser":
      return {
        nodeId: GoogleAdsAnalyserNodeIds.PROCESS_OUTPUT,
        extractSidebarData: (output) =>
          (output as GoogleAdsAnalysisData)?.analysis_response,
      };
    case "linkedin-ads-campaign-analyser":
      return {
        nodeId: LinkedinAdsAnalyserNodeIds.PROCESS_OUTPUT,
        extractSidebarData: (output) =>
          (output as LinkedinAnalysisData)?.linked_in_campaign_analysis,
      };
    case "sales-battle-card-generator":
      return {
        nodeId: SalesBattleCardGeneratorNodeIds.EXTRACT_OUTPUT_FIELDS,
        extractSidebarData: (output) => (output as RawBattleCardData)?.research_content,
      };
    default:
      return {
        nodeId: "",
        extractSidebarData: () => null,
      };
  }
}
  
// Sort rows by created_at in descending order
export const sortByCreatedAtDesc = (rows) => {
  return [...rows].sort((rowA, rowB) => {
    const dateA = new Date(rowA.created_at ?? 0).getTime();
    const dateB = new Date(rowB.created_at ?? 0).getTime();
    return dateB - dateA;
  });
};
